module.exports = __webpack_public_path__ + "static/img/b-icon-3-active.221efb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/b-icon-3-active.png
// module id = UmxV
// module chunks = 0